import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/holder/modal.module.css";

export default {
  "holder": "modal-module__holder_sDswsa__010"
};
      